// Jade Espada — product description highlighter (snippets/je-desc-insights.liquid).
// Bold phrases get a sage highlighter sweep, one after another, when the description scrolls into view.

const norm = (text) => text.replace(/\s+/g, ' ').trim();

function setup(root) {
  if (root.dataset.jeDescReady) return;
  root.dataset.jeDescReady = 'true';

  const marks = [...root.querySelectorAll('.je-desc__text strong, .je-desc__text b')].filter((el) => norm(el.textContent));
  marks.forEach((mark, i) => {
    mark.classList.add('je-mark');
    mark.style.setProperty('--je-mark-delay', `${i * 0.25}s`);
  });

  const reveal = () => marks.forEach((mark) => mark.classList.add('is-marked'));
  if (!('IntersectionObserver' in window)) return reveal();
  const io = new IntersectionObserver((entries) => {
    if (entries.some((entry) => entry.isIntersecting)) {
      reveal();
      io.disconnect();
    }
  }, { threshold: 0.4 });
  io.observe(root);
}

const init = () => document.querySelectorAll('[data-je-desc]').forEach(setup);
init();
document.addEventListener('shopify:section:load', init);
